<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start" (click)="closeScanner()">
      <ion-button>
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ng-container slot="toolbar-content">
      <ion-title class="barcode-title"> {{ title }} </ion-title>
    </ng-container>
    <ion-row slot="end" *ngIf="!hideSkip">
      <ion-button fill="clear" (click)="skipScan()">Skip</ion-button>
    </ion-row>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="qr-scan-box"></div>
</ion-content>
